import { NgOptimizedImage } from '@angular/common';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { APP_NAME, UiCoreModule } from '@forgerock/backstage-ui-core';
import {
  NgbDropdownModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbTooltipModule,
  NgbTypeaheadModule
} from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app/app.component';
import { SearchPageComponent } from './app/page/search-page/search-page.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function show(element: HTMLElement) {
  element.style.display = 'block';
}

function hide(element: HTMLElement) {
  element.style.display = 'none';
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, FormsModule, NgbTypeaheadModule, NgbPaginationModule, NgbTooltipModule,
      NgbDropdownModule, NgbNavModule, UiCoreModule, NgOptimizedImage),
    { provide: APP_NAME, useValue: 'bs_search-ui' },
    provideAnimations(),
    provideRouter([
      {
        path: '',
        component: SearchPageComponent
      }
    ])
  ]
})
  .then(() => {
    hide(document.getElementById('waitforit'));
  })
  .catch(err => {
    hide(document.getElementById('app-loading'));
    show(document.getElementById('app-error'));
    console.error(err);
  });
